import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

export type CardIconVariant = 'impact-high' | 'impact-medium' | 'impact-low' | 'happiness' | '';

@Component({
  selector: 'tidy-card-icon-block',
  templateUrl: './card-icon-block.component.html',
  styleUrls: ['./card-icon-block.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class CardIconBlockComponent {
  @Input() iconSrc = '';
  @Input() variant: CardIconVariant = '';
  @Input() size: 'default' | 'small' = 'default';
}
